import http from './http';

import { handleResponse, handleError } from './response';

const getToken = () => {
  return localStorage.getItem('token');
}

/** @param {string} resource */
const getAll = (resource) => {
    return http
        .get(resource,
            {
                headers: {
                    Authorization: 'Bearer ' + getToken()
                }
            }
        )
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param {string} id */
const getSingle = (resource, id) => {
    const token = getToken()
    return http
        .get(`${resource}/${id}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param {object} model */
const post = (resource, model) => {
    return http
        .post(resource, model)
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param {string} id */
/** @param {object} model */
const postSingle = (resource, id, model, extraConfigs) => {
    const token = getToken()
    return http
        .post(`${resource}/${id}`, model,
          {
            headers:{
              Authorization : `Bearer ${token}`,
            },
            ...extraConfigs
          })
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param {object} model */
const put = (resource, model) => {
    return http
        .put(resource, model)
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param {object} model */
const patch = (resource, model) => {
    return http
        .patch(resource, model)
        .then(handleResponse)
        .catch(handleError);
};

/** @param {string} resource */
/** @param {string} id */
const remove = (resource, id) => {
    return http
        .delete(resource, id)
        .then(handleResponse)
        .catch(handleError);
};

export const apiProvider = {
    getAll,
    getSingle,
    post,
    postSingle,
    put,
    patch,
    remove,
};
